<template>
    <ion-card data-cy="promo-card" class="promo-card my-0 mx-0">
        <div class="promo-background" />
        <ion-row class="ion-justify-content-center ion-align-items-center ion-text-center full-height">
            <ion-col class="ion-margin-horizontal px-8 text-capitalize">
                <slot></slot>
            </ion-col>
        </ion-row>
    </ion-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { IonCard, IonRow, IonCol } from '@ionic/vue';

export default defineComponent({
    components: { IonCard, IonRow, IonCol },
});
</script>

<style scoped>
.promo-card {
    --background: var(--ion-color-secondary-tint);
}
.promo-card :deep(*) {
    color: var(--ion-color-primary-contrast);
}
.promo-background {
    background: linear-gradient(125deg, transparent 10%, var(--ion-color-secondary-tint));
    -webkit-mask: url('~@/assets/100-pepperoni.svg') center/80% no-repeat;
    mask: url('~@/assets/100-pepperoni.svg') center/80% no-repeat;
    opacity: 0.6;
    position: absolute;
    height: 150%;
    width: 100%;
    filter: brightness(20%);
    overflow: hidden;
}

h3 {
    color: var(--ion-color-primary-contrast);
    margin: 0;
}
@media screen and (min-width: 960px) {
    .promo-background {
        bottom: 0;
    }
}
</style>
